module.exports = __webpack_public_path__ + "img/@logo_ls.9f47e375.png";